import { render, staticRenderFns } from "./EditContactInfoCard.vue?vue&type=template&id=2dc482dc&"
import script from "./EditContactInfoCard.vue?vue&type=script&lang=js&"
export * from "./EditContactInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports